import { h } from "@lukekaalim/act";
import { render } from "@lukekaalim/act-three";
import { TabletopApp, TabletopConfig } from "@kosmod/tabletop";
import { createLocalStorageService, FrontendPlatform } from "@kosmod/core";
import { createConsoleLogStreamRenderer, createLogStreamProvider } from "@kosmod/kit";
import { Network } from "@kosmod/pancake";
import { v2 } from '@lukekaalim/act-router';

const logProvider = createLogStreamProvider();
const network = Network.web(window.fetch, window.WebSocket);

createConsoleLogStreamRenderer(logProvider.emitter);

const platform: FrontendPlatform = {
  logger: logProvider.createLogger('kosmod.app'),
  net: {
    http: network.createHTTPClient(),
    ws: network.createWSClient(),
    rtc: null as any,
  },
  router: new v2.URLRouter(document.location.href),
  storage: createLocalStorageService(window.localStorage)
};
const devConfig: TabletopConfig = {
  apiBaseURL: new URL(`http://localhost:10000`),
  frontendBaseURL: new URL(`http://localhost:5173`),
  
  asset: {
    strategy: { type: 'api-url' }
  }
}
const prodConfig: TabletopConfig = {
  apiBaseURL: new URL(`https://api.beta.kosmod.dev`),
  frontendBaseURL: new URL(`https://beta.kosmod.dev`),
  
  asset: {
    strategy: { type: 'api-url' }
  }
}

export const KosmodApp = () => {
  v2.useDOMIntegration(platform.router)

  return h(TabletopApp, {
    platform,
    config: document.location.hostname === 'localhost' ? devConfig : prodConfig
  })
};

render(h(KosmodApp), document.body);